import { useEffect } from "react";
import { setDocumentTitle } from "@/lib/documentTitle";
import { R1DashboardProvider } from "@/features/R1Dashboard/context/R1DashboardProvider";
import EmailLogsView from "@/features/R1Dashboard/views/EmailLogsView";

export default function R1EmailLogs() {
  useEffect(() => {
    setDocumentTitle("Quantilia | Emails");
  }, []);

  return (
    <R1DashboardProvider>
      <main className="min-h-0 flex flex-1 flex-col overflow-auto bg-white p-5">
        <EmailLogsView />
      </main>
    </R1DashboardProvider>
  );
}
